export enum RESOURCE_BUNDLES {
  HEADER = 'roots.header',
  FOOTER = 'roots.footer',
}
